import type { SxProps, Theme } from '@mui/material/styles';

/** Concatenates sx values (objects, callbacks or arrays) as MUI recommends for components that accept `sx`. */
export function mergeSx(...parts: (SxProps<Theme> | undefined | false)[]): SxProps<Theme> {
  const out: unknown[] = [];
  for (const p of parts) {
    if (!p) continue;
    if (Array.isArray(p)) out.push(...(p as readonly unknown[]));
    else out.push(p);
  }
  return out as SxProps<Theme>;
}
